/* @flow */

const onOpenAlterarEtapaEntrega = () => {
    const entregador = document.getElementById('entregador-atendimento');
    const loggi = document.getElementById('loggi-atendimento');
    if (entregador instanceof HTMLSelectElement && loggi instanceof HTMLInputElement) {
        entregador.onchange = () => {
            if (entregador.value) {
                loggi.checked = false;
            }
        };

        loggi.onchange = () => {
            if (loggi.checked) {
                entregador.value = '';
            }
        };
    }
};


export default onOpenAlterarEtapaEntrega;
